<template>
  <div class="w-full bg-white height-100">
    <el-dialog
      title=""
      :visible.sync="isShowpop"
      width="35%"
      class="ishidePopup"
    >
      <div class="p-4">
        <div class="flex justify-between w-full items-start">
          <div>
            <h3 class="text-xl font-semibold text-dark">Admin Panel Access</h3>
            <div class="flex items-center gap-2 mt-1">
              <p class="text-dark fsize12 font-semibold">Project Status</p>
              <p class="text-success font-semibold">
                {{ projectPopupDetails.projectStatus }}
              </p>
            </div>
          </div>
          <feather-icon icon="InfoIcon" />
        </div>
        <div class="mt-5 rounded-full bg-ec px-4 py-3 w-full">
          <div class="flex justify-between w-full items-center">
            <div class="flex items-center gap-2">
              <feather-icon
                icon="LockIcon"
                class="text-success mt-2"
                svgClasses="w-4 h-4"
              />
              <h4 class="fsize14 font-semibold text-dark">
                {{ adminURL }}
              </h4>
            </div>
            <a :href="adminURL" target="_blank" class="mt-2">
              <feather-icon
                v-if="adminDetails.AutoDNSDeploy == 1"
                icon="ExternalLinkIcon"
                svgClasses="w-4 h-4"
                class="cursor-pointer"
              />
            </a>
          </div>
        </div>
        <div class="mt-5">
          <p class="text-black mt-2 text-sm">
            Head overto this URL and use your BRAINED Partner email ID to
            register as an admin to manage your client's project & check project
            development statuses
          </p>
          <div class="mt-5 bg-ffec77 p-5 rounded-lg">
            <p class="text-black fsize14">
              Note: You will need to complete your one-time registration once
              you access this URL
            </p>
          </div>
        </div>
      </div>
    </el-dialog>
    <div class="seth-set bg-primary">
      <div class="absolute top-0 py-10 w-full px-6">
        <p
          @click="handleBack"
          class="gap-2 cursor-pointer fsize14 mb-1 text-white flex items-center font-medium"
        >
          <feather-icon
            class="flex"
            icon="ArrowLeftIcon"
            svgClasses="w-6 h-6"
          />
          Go Back
        </p>
        <h2 class="text-white pt-1 text-2xl capitalize font-semibold">
          Project Management
        </h2>
      </div>
    </div>
    <div class="px-6 fixed-top py-8 bg-white">
      <div class="w-full">
        <div class="w-full flex items-center justify-between">
          <div class="w-4/12">
            <div>
              <small class="fsize12 bg-white text-dark font-medium"
                >Search Keywords</small
              >
              <div class="relative">
                <el-input
                  placeholder="Search"
                  class="w-full mt-2"
                  v-model="searchQuery"
                  @onchange="input"
                ></el-input>
                <div class="absolute topright-adj bg-white cursor-pointer">
                  <feather-icon
                    icon="SearchIcon"
                    @click="getAllProject()"
                    svgClasses="w-6 h-6"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="w-8/12 flex items-end gap-2 pl-2">
            <div class="w-10/12 flex gap-3">
              <div class="">
                <small class="fsize12 bg-white text-dark font-medium"
                  >Search From
                </small>
                <el-date-picker
                  v-model="from"
                  type="date"
                  placeholder="Pick a day"
                  class="mt-2 w-full"
                  @change="dateChange"
                >
                </el-date-picker>
              </div>
              <div class="">
                <small class="fsize12 bg-white text-dark font-medium"
                  >Search to</small
                >
                <el-date-picker
                  v-model="to"
                  type="date"
                  placeholder="Pick a day"
                  class="mt-2 w-full"
                  @change="dateChange"
                >
                </el-date-picker>
              </div>
            </div>
            <div class="w-2/12 flex justify-end">
              <vs-button
                @click="toProject()"
                class="bg-primary px-5 py-3 border-none rounded-lg text-white flex items-center"
              >
                Add New
              </vs-button>
            </div>
          </div>
        </div>
        <div class="w-full grid grid-cols-3 gap-4 mt-8">
          <div
            class="flex items-center bg-white cursor-pointer elshadow border-round p-4"
            v-for="(item, index) in projectCards"
            :key="('item-', +index)"
            @click="handlePopup(item)"
          >
            <div class="flex gap-4 w-10/12">
              <img
                :src="getProjectImage(item)"
                alt="projectlogo"
                class="w-20 h-24 object-contain bg-cas rounded-lg"
              />

              <div class="w-full">
                <small class="col-4f fsize10 font-medium">{{
                  showplan(item.selectedPlan[item.selectedPlan.length - 1])
                }}</small>
                <h3
                  class="col-4f fsize16 font-semibold mb-0 flex gap-1 items-center"
                >
                  {{ item.displayName }}
                </h3>
                <div class="flex justify-between w-full mt-2">
                  <div>
                    <p class="fsize10 font-semibold mb-0 col-4f">Date</p>
                    <p class="fsize10 mb-0 text-8f8f8f">
                      {{ showDate(item.createdAt) }}
                    </p>
                  </div>
                  <div>
                    <p class="fsize10 font-semibold mb-0 col-4f">Status</p>
                    <p
                      class="fsize10 mb-0 font-semibold"
                      :class="{
                        textwarning: item.status === 'pending',
                        'text-success': item.status === 'approved',
                        textdanger: item.status === 'rejected',
                      }"
                    >
                      {{ item.projectStatus }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="w-2/12 flex justify-end cursor-pointer">
              <div>
                <div
                  class="flex justify-center bg-light-secondary rounded-full items-center w-12 h-12"
                >
                  <feather-icon
                    icon="ChevronRightIcon"
                    svgClasses="w-5 h-5"
                    class="text-secondary font-semibold flex"
                  />
                </div>
              </div>
            </div> -->
          </div>
        </div>

        <div class="w-full flex justify-end mt-6">
          <el-pagination
            @current-change="
              (value) => {
                currentPage = value;
                getAllProject();
              }
            "
            :per-size="perPage"
            :total="totalLength"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
// import FeatherIcon from "../../../../../../components/FeatherIcon.vue";

// import VueEllipseProgress from "vue-ellipse-progress";
const debounce = function debounce(func, wait = 800) {
  let debounceTimer;
  return function (...args) {
    if (debounceTimer) clearTimeout(debounceTimer);
    const context = this;
    debounceTimer = setTimeout(() => {
      func.apply(context, args);
    }, wait);
  };
};
export default {
  data() {
    return {
      projectPopupDetails: "",
      projectCards: [],
      FeatherIconselectedCampaign: "",
      isShowpop: false,
      value0: "SMS",
      value1: "",
      currentPage: 1,
      perPage: 10,
      totalLength: 0,
      status: "",
      reason: "",
      date1: "",
      date2: "",
      input: "",
      image1Source: "",
      image2Source: "",
      image3Source: "",
      image4Source: "",
      image5Source: "",
      image1: "",
      selectedCampaign: "",
      image2: "",
      image3: "",
      image4: "",
      body1: "",
      body2: "",
      body3: "",

      img: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEkA…0QRu0QRu0QRu0QXt3tP8DVgJyJnMS4S8AAAAASUVORK5CYII=",
      Cards: [],
      getMyData: "",
      dateCon1: "",
      dateCon2: "",
      url: "",
      smsBody: "",
      pushBody: "",
      pushtitle: "",
      templateName: "",
      whatsappBody: "",
      templateId: "",
      searchQuery: "",
      from: "",
      to: "",
      adminURL: "",
      adminDetails: "",
    };
  },
  methods: {
    handlePopup(item) {
      this.isShowpop = true;
      this.projectPopupDetails = item;
      if (item.repos.length) {
        this.adminDetails = item.repos.filter((x) => (x.type = "admin"))[0];
        if (this.adminDetails.AutoDNSDeploy == 1) {
          this.adminURL = `${adminDetails.name}.brained.in`;
        } else this.adminURL = "Brained Panel is being deployed";
      }
    },
    showplan(value) {
      if (value)
        if (value.subscription)
          if (value.subscription.name) return value.subscription.name;
    },
    toProject() {
      this.$router.push({ name: "ProjectRegister" });
    },
    showDate(value) {
      return new Date(value).toDateString();
    },
    getProjectImage(value) {
      if (value.hasOwnProperty("isDeleted") && value.isDeleted) {
        return `${process.env.VUE_APP_IMAGE_URL}/Cera/Assets/Junk.png`;
      } else {
        if (value.source === "Website")
          return `${process.env.VUE_APP_IMAGE_URL}/Cera/Assets/website.png`;
        else if (value.source === "Reseller" || value.projectType == "Reseller")
          return `${process.env.VUE_APP_IMAGE_URL}/Cera/Assets/reseller.png`;
        else if (value.source === "Reseller-Offer")
          return `${process.env.VUE_APP_IMAGE_URL}/Cera/Assets/reseller-offer.png`;
        else if (value.projectType === "Base")
          return `${process.env.VUE_APP_IMAGE_URL}/Cera/Assets/suite.png`;
        else if (value.source === "Cera")
          return `${process.env.VUE_APP_IMAGE_URL}/Dash/projects/default_project.png`;
        else return `${process.env.VUE_APP_IMAGE_URL}/Cera/Assets/website.png`;
      }
    },
    // async handleNext() {
    //   try {
    //     let payload = {
    //       campaign: this.value0,
    //       offset: (this.currentPage - 1) * 10,
    //     };
    //   } catch (err) {}
    // },
    handleClick() {
      this.$router.push({ name: this.selectedCampaign });
    },

    dateChange() {
      if (this.from && this.to) {
        this.getAllProject();
      }
    },
    async getAllProject() {
      let payload = {
        limit: this.perPage,
        offset: this.perPage * this.currentPage - this.perPage,
        resellerId: this.login.reseller,
      };
      if (this.searchQuery)
        Object.assign(payload, { projectName: this.searchQuery });
      if (this.from && this.to) {
        Object.assign(payload, { from: this.from, to: this.to });
      }
      console.log(payload, "page");
      let requestdata = await this.$store.dispatch(
        "projectFile/getAllProject",
        payload
      );
      this.projectCards = requestdata.data.data;
      this.totalLength = requestdata.data.count;
    },
  },
  async mounted() {
    await this.getAllProject();
    // this.value0 = "SMS";
  },
  computed: {
    ...mapState("user", { selectedProject: "selectedProject" }),
    ...mapState("brandProfile", ["brandProfile"]),
    ...mapState("admin", ["login"]),
  },
};
</script>
<style>
.bg-ffec77 {
  background: #ffecc7 !important;
}
</style>
